import { useState } from 'react';
import { feeds } from '@/mocks/home';

const CHANNELS = ['全部', '高能', '大瓜', '劲爆', '猛料', '辟谣'];

export default function NewsFeed() {
  const [active, setActive] = useState('全部');
  const list = active === '全部' ? feeds : feeds.filter((f) => f.cat === active);

  return (
    <section id="feed" className="relative w-full bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-semibold tracking-widest text-primary-600">
              <i className="ri-flashlight-fill" /> BREAKING
            </span>
            <h2 className="mt-1 font-heading text-2xl font-black text-foreground-950 md:text-3xl">
              猛料速递 · 封面直击
            </h2>
          </div>
          <div className="inline-flex w-full gap-1 rounded-full border border-background-300/80 bg-background-50 p-1 sm:w-auto">
            {CHANNELS.map((c) => (
              <button
                key={c}
                type="button"
                onClick={() => setActive(c)}
                className={`whitespace-nowrap cursor-pointer rounded-full px-3.5 py-1.5 text-sm font-semibold transition-colors md:px-4 ${
                  active === c
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-600 hover:text-foreground-900'
                }`}
              >
                {c}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-7 grid grid-cols-1 gap-x-5 gap-y-7 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {list.map((item, idx) => (
            <a
              key={item.title}
              href="#feed"
              className="group flex cursor-pointer flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all hover:-translate-y-1 hover:border-background-300"
            >
              <div className="relative aspect-[3/4] overflow-hidden">
                <img
                  src={item.cover}
                  alt={item.title}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 inline-flex items-center gap-1 rounded-md bg-primary-500 px-2 py-1 text-xs font-bold text-background-50">
                  {item.tag}
                </span>
                {idx === 0 && (
                  <span className="absolute right-3 top-3 inline-flex items-center gap-1 rounded-md bg-accent-500 px-2 py-1 text-xs font-bold text-background-50">
                    <i className="ri-flashlight-fill" /> 热
                  </span>
                )}
                <div className="absolute inset-x-0 bottom-0 h-16 bg-gradient-to-t from-black/55 to-transparent" />
                <span className="absolute bottom-3 left-3 right-3 text-xs font-medium text-background-50/90">
                  <i className="ri-eye-line mr-1" />
                  {item.views} 围观
                </span>
              </div>
              <div className="flex flex-1 flex-col p-4">
                <h3 className="line-clamp-2 text-sm font-bold leading-snug text-foreground-950 group-hover:text-primary-700 md:text-base">
                  {item.title}
                </h3>
                <p className="mt-2 line-clamp-2 text-xs leading-relaxed text-foreground-600 md:text-[13px]">
                  {item.summary}
                </p>
                <div className="mt-3 flex items-center justify-between border-t border-background-100 pt-3 text-xs text-secondary-500">
                  <span>
                    <i className="ri-time-line mr-1" />
                    {item.time}
                  </span>
                  <span className="flex items-center gap-3">
                    <span>
                      <i className="ri-message-2-line mr-1" />
                      {item.replies}
                    </span>
                    <i className="ri-arrow-right-up-line text-sm text-secondary-400 transition-colors group-hover:text-primary-500" />
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-10 text-center">
          <button
            type="button"
            className="inline-flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-secondary-400"
          >
            加载更多猛料 <i className="ri-arrow-down-line" />
          </button>
        </div>
      </div>
    </section>
  );
}